/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TechnicalVisitAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_PROVIDER = 'autocomplete-provider',
  BREADCRUMB_0 = 'breadcrumb-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_VISIT = 'deck-visit',
  FETCH_0 = 'fetch-0',
  FETCH_PROVIDER = 'fetch-provider',
  FETCH_VISIT = 'fetch-visit',
  FIELD_1 = 'field-1',
  FIELD_DATE = 'field-date',
  FIELD_DOMAIN = 'field-domain',
  FIELD_PROVIDER = 'field-provider',
  FILTER_TECHNICAL_VISIT = 'filter-technical-visit',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD_VISIT = 'hpms-custom-card-visit',
  LAYOUT_0 = 'layout-0',
  LAYOUT_VISIT = 'layout-visit',
  MAPPER_0 = 'mapper-0',
  MAPPER_DOMAIN = 'mapper-domain',
  PANEL_MAIN = 'panel-main',
  PANEL_TITLE = 'panel-title',
  PANEL_VISIT = 'panel-visit',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_DOMAIN = 'text-domain',
  TEXT_PROVIDER = 'text-provider',
}
export { TechnicalVisitAliases };
